import { Settings, Users } from "lucide-react";

import { TooltipProvider } from "@/components/ui/tooltip";

import { useVidyoStore } from "../utils/vidyo-store";

import { ActionButton } from "./action-button";
import { RecordCall } from "./action-buttons/record-call";
import { ToggleCaption } from "./action-buttons/toggle-caption";
import { ToggleModeration } from "./action-buttons/toggle-moderation";

export function SettingsBar() {
  const openSettingsDrawer = useVidyoStore((s) => s.settingsDrawer.open);
  const closeSettingsDrawer = useVidyoStore((s) => s.settingsDrawer.close);
  const isSettingsDrawerOpen = useVidyoStore((s) => s.settingsDrawer.isOpen);

  const openParticipantsDrawer = useVidyoStore(
    (s) => s.participantsDrawer.open,
  );
  const isParticipantsDrawerOpen = useVidyoStore(
    (s) => s.participantsDrawer.isOpen,
  );
  const closeParticipantsDrawer = useVidyoStore(
    (s) => s.participantsDrawer.close,
  );

  return (
    <div className="flex items-center gap-1">
      <TooltipProvider>
        <RecordCall variant="ghost" size="auto" key="record" />
        <ToggleCaption variant="ghost" size="auto" key="caption" />

        <ActionButton
          onClick={
            isParticipantsDrawerOpen
              ? closeParticipantsDrawer
              : openParticipantsDrawer
          }
          Icon={Users}
          text="Participants"
          variant="ghost"
          size="auto"
          isActive={isParticipantsDrawerOpen}
        />
        <ActionButton
          onClick={
            isSettingsDrawerOpen ? closeSettingsDrawer : openSettingsDrawer
          }
          Icon={Settings}
          text="Settings"
          variant="ghost"
          size="auto"
          isActive={isSettingsDrawerOpen}
        />
        <ToggleModeration variant="ghost" size="auto" />
      </TooltipProvider>
    </div>
  );
}
